/**
 * The "animal photo" glyph: a camera with a paw print where the lens would be.
 *
 * The no-photo placeholders in the search results and the thumbnails already drew this (as a CSS
 * data-URI); the icon-sized spots still used a plain lucide camera, so the same idea showed up in two
 * different drawings. One component, one drawing — used wherever the subject is an ANIMAL's photo. A
 * camera on an action button ("Foto maken", "Scan paspoort") stays a plain camera: that is about the
 * act of taking a picture, not about the animal.
 */
export function CameraPawIcon({
  size = 20,
  strokeWidth = 1.4,
}: {
  size?: number;
  strokeWidth?: number;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      {/* The paw: pad + four toes, filled so it reads at 16px. */}
      <g fill="currentColor">
        <ellipse cx="12" cy="15" rx="2.3" ry="1.7" />
        <circle cx="8.6" cy="12.3" r="0.95" />
        <circle cx="10.9" cy="11" r="0.95" />
        <circle cx="13.1" cy="11" r="0.95" />
        <circle cx="15.4" cy="12.3" r="0.95" />
      </g>
    </svg>
  );
}
